
import Vue from 'vue'
export default Vue.extend({
  name: 'Unauthorized',
  components: {
  },
  data() {
    return {};
  },
  methods: {
    
  },
  created() {
    // 登出後馬上要求重新登入:
    // userManager.signinRedirect();

    // 登出後前往 Non-Login Match Page:
    this.$router.replace({ name: 'NonLoginBusinessMatch' });
    
  },
})
